import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { BLANK_RULE, DEFAULT_RULE } from '../helpers/rules';
import { getErrorMessage } from '../helpers/errors';
import { getRule } from '../actions/ruleActions';
import useIsMounted from './useIsMounted';

const DEFAULT_RESPONSE = Object.freeze({
    error:   null,
    loading: false,
    meta:    null
});

let IS_FETCHING = false;

export default function useRule() {
    const isMounted = useIsMounted();
    const dispatch = useDispatch();
    const [response, setResponse] = useState({ ...DEFAULT_RESPONSE });
    const [ruleId, setRuleId] = useState();
    const rule = useSelector(
        ({ rules }) => {
            if (ruleId) {
                return rules.items[ruleId] || BLANK_RULE;
            }
            return DEFAULT_RULE;
        }
    );

    useEffect(() => {
        if (!ruleId || IS_FETCHING) {
            return;
        }
        IS_FETCHING = true;
        async function runFetch() {
            setResponse({
                ...DEFAULT_RESPONSE,
                error:   null,
                loading: true
            });
            try {
                const resp = await dispatch(getRule(ruleId));
                if (!isMounted.current) {
                    return;
                }
                setResponse({
                    ...DEFAULT_RESPONSE,
                    complete: true,
                    loading:  false,
                    meta:     resp.data.meta
                });
            } catch (error) {
                setResponse({
                    ...DEFAULT_RESPONSE,
                    error: getErrorMessage(error)
                });
            } finally {
                IS_FETCHING = false;
            }
        }
        runFetch();
    }, [ruleId]);

    return [
        {
            ...response,
            data: rule
        },
        (ruleId) => setRuleId(ruleId)
    ];
}
